type Props = {
  className?: string;
  size?: number;
  color?: string;
};

const OctagonAlertIcon = ({ className = "", color = "#115E59" }: Props) => {
  return (
    <svg
      width="62"
      height="62"
      viewBox="0 0 62 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M31 3.5C46.1878 3.5 58.5 15.8122 58.5 31C58.5 46.1878 46.1878 58.5 31 58.5C15.8122 58.5 3.5 46.1878 3.5 31C3.5 15.8122 15.8122 3.5 31 3.5Z"
        fill="#CCFBF1"
      />
      <path
        d="M31 3.5C46.1878 3.5 58.5 15.8122 58.5 31C58.5 46.1878 46.1878 58.5 31 58.5C15.8122 58.5 3.5 46.1878 3.5 31C3.5 15.8122 15.8122 3.5 31 3.5Z"
        stroke="#F0FDFA"
        strokeWidth="7"
      />
      <path
        d="M26.5153 20.1665H35.4853L41.8337 26.5148V35.4848L35.4853 41.8332H26.5153L20.167 35.4848V26.5148L26.5153 20.1665Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M31 26.6665V30.9998" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M31 35.3335H31.0108" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default OctagonAlertIcon;
